
So far, this is mostly taken from https://ballotpedia.org/Presidential_candidates,_2020. The plan is to add more as I start to do my research.

I am not registered with _either_ (why are there only two?) political party.

# Useful Resources

- [New Statements of Candidacy](https://classic.fec.gov/data/Form2Filer.do?format=html)
  - [all](https://classic.fec.gov/data/Form2Filer.do?format=json&candidateName=&party=&candidateOffice=P&candidateOfficeStateABV=&candidateOfficeDisctrict=&election_yr=&receiptDate=&receiptEndDate=)
  - [dems](https://classic.fec.gov/data/Form2Filer.do?format=json&candidateName=&party=Democratic%20Party&candidateOffice=P&candidateOfficeStateABV=&candidateOfficeDisctrict=&election_yr=&receiptDate=&receiptEndDate=)
  - [repubs](https://classic.fec.gov/data/Form2Filer.do?format=json&candidateName=&party=Republican%20Party&candidateOffice=P&candidateOfficeStateABV=&candidateOfficeDisctrict=&election_yr=&receiptDate=&receiptEndDate=)

# Filed Notables

The following elected officials have filed to run for president with the Federal Election Commission or announced exploratory committees.

- Julian Castro (D), a former U.S. secretary of housing and urban development and San Antonio mayor, formally announced his candidacy on January 12, 2019.

- John Delaney (D), a former U.S. representative from Maryland, filed to run for president on August 10, 2017.

- Tulsi Gabbard (D), a U.S. representative from Hawaii, announced that she had decided to run for president on January 11, 2019.

- Kirsten Gillibrand (D), a U.S. senator from New York, announced that she was running for president on January 15, 2019.

- Kamala Harris (D), a U.S. senator from California, announced that she was running for president on January 21, 2019.
  - first female and Asian American to ever serve as President of the United States, in addition to being the second African American elected president following President Barack Obama in 2008. She will be 56 years old on Inauguration Day in January 2021
  - Harris is the third black woman to seek the Democratic nomination for president, the first two being Congresswoman Shirley Chisholm in 1972 and Sen. Carol Moseley Braun in 2004 (the latter of whom is also the only other black woman to have ever served in the U.S. Senate)
  - "Hell-No Caucus" by Politico in 2018, along with Senators Cory Booker, Kirsten Gillibrand, Elizabeth Warren and Bernie Sanders, given she voted "overwhelmingly to thwart his (Trump's) nominees for administration jobs"

- Richard Ojeda (D), a state senator from West Virginia, filed to run for president on November 11, 2018.

- President Donald Trump (R) filed to run for re-election in 2020 on January 20, 2017.

- Elizabeth Warren (D), U.S. senator from Massachusetts, announced she had formed an exploratory committee on December 31, 2018.


# Dems

Politicians


- Stacey Abrams, former member and minority leader, Georgia House of Representatives
- Michael Bennet, U.S. senator from Colorado
- Joe Biden, former vice president of the United States
- Michael Bloomberg, former mayor of New York City
- Cory Booker, U.S. senator from New Jersey
- Jerry Brown, former governor of California
- Sherrod Brown, U.S. senator from Ohio
- Steve Bullock, governor of Montana
- Pete Buttigieg, mayor of South Bend, Indiana
- Lincoln Chafee, former governor of and U.S. senator from Rhode Island
- Hillary Clinton, former U.S. secretary of state and 2016 Democratic presidential nominee
- Roy Cooper, governor of North Carolina
- Bill de Blasio, mayor of New York, New York
- Eric Garcetti, mayor of Los Angeles, California
- Andrew Gillum, former mayor of Tallahassee
- Luis Gutierrez, former U.S. representative from Illinois
- Maggie Hassan, U.S. senator from New Hampshire
- John Hickenlooper, former governor of Colorado
- Eric Holder, former attorney general of the United States
- Jay Inslee, governor of Washington
- Tim Kaine, U.S. senator from Virginia and 2016 Democratic vice presidential nominee
- Jason Kander, former secretary of state of Missouri
- Joe Kennedy III, U.S. representative from Massachusetts
- John Kerry, former secretary of state of the United States and U.S. senator from Massachusetts
- Amy Klobuchar, U.S. senator from Minnesota
- Mitch Landrieu, former mayor of New Orleans, Louisiana
- Terry McAuliffe, former governor of Virginia
- Jeff Merkley, U.S. senator from Oregon
- Seth Moulton, U.S. representative from Massachusetts
- Martin O'Malley, former governor of Maryland
- Beto O'Rourke, former U.S. representative from Texas
- Chris Murphy, U.S. senator from Connecticut
- Gina Raimondo, governor of Rhode Island
- Tim Ryan, U.S. representative from Ohio
- Brian Schatz, U.S. senator from Hawaii
- Bernie Sanders (I), U.S. senator from Vermont
- Adam Schiff, U.S. representative from California
- Eric Swalwell, U.S. representative from California
- Sally Yates, former acting attorney general

Business executives and public figures

- Jamie Dimon, CEO of JPMorgan Chase
- Bill Gates, founder of Microsoft and co-chair of the Bill & Melinda Gates Foundation
- Bob Iger, CEO of Disney
- Dwayne "The Rock" Johnson, actor and professional wrestler
- Michelle Obama, former first lady of the United States
- Howard Schultz, former CEO of Starbucks
- Oprah Winfrey, mass media owner and philanthropist
- Andrew Yang, Venture for America founder
- Mark Zuckerberg, Facebook founder

# Republicans

Politicians

- Bob Corker, former U.S. senator from Tennessee
- Tom Cotton, U.S. senator from Arkansas
- Ted Cruz, U.S. senator from Texas
- Jeff Flake, former U.S. senator from Arizona
- Nikki Haley, former U.S. ambassador to the United Nations and former governor of South Carolina
- Larry Hogan, governor of Maryland
- John Kasich, former governor of Ohio
- Susana Martinez, former governor of New Mexico
- Mike Pence, vice president of the United States
- Mitt Romney, former governor of Massachusetts
- Ben Sasse, U.S. senator from Nebraska
- Scott Walker, former governor of Wisconsin

Business executives and public figures

- Mark Cuban, investor and owner of the Dallas Mavericks
- Carly Fiorina, former CEO of Hewlett-Packard
